<template>
    <div>
        <GlobalNav />

        <!-- Hero -->
        <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:mx-auto md:grid-cols-4 max-w-7xl divide-dashed">
            <div class="h-16" />
            <div />
            <div />
            <div />
        </div>
        <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:mx-auto md:grid-cols-4 max-w-7xl divide-dashed">
            <h1 class="col-span-2 p-4 text-5xl font-bold text-white">
                We help you create virtual worlds
            </h1>
            <div />
            <div />
        </div>
        <div class="grid grid-cols-2 mx-2 text-gray-400 border-t border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:mx-auto md:grid-cols-4 max-w-7xl divide-dashed">
            <div class="col-span-2 p-4 text-lg md:col-span-1">
                <p>Game Development is complicated, but it doesn't have to be.</p>
                <p class="mt-2">
                    We provide tools, content, and tutorials to help you realize your projects.
                </p>
                <BaseButton
                    class="mt-4"
                    to="#featured-assets"
                >
                    Show Me
                </BaseButton>
            </div>
            <div class="col-span-2 p-4 md:col-span-3">
                <img
                    :src="HomeFeaturedImg"
                    class="object-cover w-full rounded md:h-[450px]"
                >
            </div>
        </div>

        <!-- Main Cards -->
        <div
            v-if="showMainCards"
            class="grid grid-cols-4 mx-auto overflow-visible text-gray-400 border-t border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 max-w-7xl divide-dashed"
        >
            <a
                v-for="(card, index) in mainCards"
                :key="index"
                class="relative flex flex-col justify-between gap-2 p-4 overflow-visible group"
                href="#"
            >
                <div class="absolute transition-transform duration-75 ease-out scale-95 bg-gray-800 bg-opacity-100 rounded opacity-0 -inset-px group-hover:scale-100 group-hover:opacity-100" />
                <div class="flex flex-col gap-2">
                    <component
                        :is="card.icon"
                        class="relative text-purple-400 w-7 h-7"
                    />
                    <h2 class="relative pl-4 -ml-4 text-xl font-semibold text-white">
                        <div class="absolute top-0 left-0 w-px h-full -ml-px transition-opacity bg-purple-400" />
                        {{ card.title }}
                    </h2>
                    <p class="relative p-0">
                        {{ card.content }}
                    </p>
                </div>
                <p
                    class="relative text-purple-400 group-hover:underline group-hover:text-purple-300"
                >See how
                </p>
            </a>
        </div>
        <div class="grid grid-cols-2 mx-2 text-gray-300 border-t border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed ">
            <div class="h-48" />
            <div />
            <div />
            <div />
        </div>

        <!-- Testimonials -->
        <div v-if="showFeaturedTestimonial">
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 mdgrid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div />
                <div class="col-span-2 p-4">
                    <img
                        :src="FenixFireLogo"
                        class="object-cover h-8 mx-auto rounded"
                    >
                </div>
                <div />
            </div>
            <div class="grid grid-cols-4 mx-auto text-gray-300 border-gray-800 border-dashed divide-gray-800 max-w-7xl divide-dashed">
                <div class="border border-gray-600 border-dashed col-span-full">
                    <img :src="HighlightBannerImg">
                </div>
            </div>
            <div class="grid grid-cols-4 mx-auto text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 max-w-7xl divide-dashed">
                <div class="col-span-2 p-4">
                    <div class="flex items-center gap-4 p-4 bg-gray-800 rounded shadow-md">
                        <div>
                            <div class="block w-32 h-32 overflow-hidden bg-gray-700 rounded shadow">
                                <img
                                    alt=""
                                    class="block w-full h-full"
                                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                >
                                <!--
                                <svg
                                  class="w-full h-full text-gray-300"
                                  fill="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                                </svg> -->
                            </div>
                        </div>
                        <div>
                            <h3 class="font-semibold text-white">
                                "A quote from you will be in this box, describing how you used our assets in your
                                project."
                            </h3>
                            <p class="mt-4">
                                <span class="font-medium text-white">Name</span>, CEO, Company Corp
                            </p>
                        </div>
                    </div>
                </div>
                <div class="flex flex-col justify-between col-span-2 p-0">
                    <div class="p-4">
                        <h2 class="text-3xl font-semibold text-white">
                            <span class="text-purple-400">Fenix Fire</span> realized their project
                            <span class="text-purple-400">Osiris: New Dawn</span> with Nature Renderer
                        </h2>
                        <p class="mt-2">
                            Osiris: New Dawn is an unforgiving near future space survival game with a cinematic feel and
                            elements of horror. Play as a Mission Specialist in single or multiplayer to build your
                            planetary base, pilotable vehicles, and controllable drones as you explore a dangerous solar
                            system far from Earth.
                        </p>
                    </div>
                    <div class="flex gap-4 p-4 border-t border-gray-800 border-dashed">
                        <BaseButton variant="outline">
                            Website
                            <OpenInNewIcon
                                :size="'1.2em'"
                                class="inline-block ml-0 align-middle transform -translate-y-px"
                            />
                        </BaseButton>
                        <BaseButton variant="outline">
                            Steam
                            <OpenInNewIcon
                                :size="'1.2em'"
                                class="inline-block ml-0 align-middle transform -translate-y-px"
                            />
                        </BaseButton>
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-4 mx-auto text-gray-300 border-t border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 max-w-7xl divide-dashed">
                <div class="h-32" />
                <div />
                <div />
                <div />
            </div>
        </div>

        <!-- Reviews -->
        <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:mx-auto md:grid-cols-4 max-w-7xl divide-dashed">
            <div class="hidden md:block" />
            <div class="col-span-2 p-4">
                <h2 class="text-3xl font-semibold text-center text-white">
                    We already helped over 26,000 developers realize their projects.
                </h2>
                <p class="mt-2 text-center">
                    Here is what they say about our assets:
                </p>
            </div>
            <div class="hidden md:block" />
            <div
                v-for="(review, index) in filteredReviews"
                :key="index"
                class="p-4 bg-gray-900 border-t"
            >
                <div class="flex flex-col justify-between h-full p-4 bg-gray-800 rounded shadow-md">
                    <div>
                        <h3 class="font-semibold text-white">
                            {{ review.title }}
                        </h3>
                        <p class="mt-2 text-sm">
                            {{ review.content }}
                        </p>
                    </div>
                    <p class="mt-4 text-sm text-purple-300">
                        <span class="inline-flex items-center justify-center w-6 h-6 mr-3 bg-purple-500 rounded-full">
                            <span class="text-xs font-medium leading-none text-white">{{ review.user.charAt(0).toUpperCase() }}</span>
                        </span>
                        {{ review.user }}
                    </p>
                </div>
            </div>
            <div
                v-if="reviewCount < reviews.length"
                class="p-4 border-t"
            />
            <div
                v-if="reviewCount < reviews.length"
                class="flex justify-center col-span-2 p-4 border-t"
            >
                <BaseButton
                    variant="outline"
                    @click="onShowMoreReviewsClicked"
                >
                    Show More
                </BaseButton>
            </div>
            <div
                v-if="reviewCount < reviews.length"
                class="p-4 border-t"
            />
        </div>
        <div class="grid grid-cols-2 mx-2 text-gray-300 border-t border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
            <div class="h-48" />
            <div />
            <div />
            <div />
        </div>

        <!-- Featured Assets -->
        <div
            v-if="showFeaturedAssets"
            id="featured-assets"
        >
            <!-- Banner -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-gray-800 border-dashed divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div class="border border-gray-600 border-dashed col-span-full">
                    <img
                        :src="FeaturedBannerImg"
                        class="md:h-[360px] object-cover w-full"
                    >
                </div>
            </div>

            <!-- Header -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-b border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div class="col-span-2 p-4">
                    <p class="mb-2 text-sm text-purple-400">
                        <StarIcon class="inline-block w-4 h-4 -mt-px" />
                        Featured
                    </p>
                    <h2 class="text-3xl font-semibold text-white">
                        Assets to create realistic worlds
                    </h2>
                    <p class="mt-2">
                        Take a look at these tools and assets that help you create photo-realistic worlds.
                    </p>
                </div>
                <div />
                <div />
            </div>

            <!-- Cards -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-b border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <router-link
                    v-for="(card, index) in featuredProductCards"
                    :key="index"
                    :to="card.to"
                    class="relative flex flex-col justify-between col-span-1 gap-2 p-4 overflow-visible group"
                >
                    <div class="absolute transition-transform duration-75 ease-out scale-95 bg-gray-800 bg-opacity-100 rounded opacity-0 -inset-px group-hover:scale-100 group-hover:opacity-100" />
                    <div class="flex flex-col gap-2">
                        <img
                            :src="card.image"
                            class="relative object-cover w-full rounded shadow-md group-hover:drop-shadow-lg"
                        >
                        <h2 class="relative pl-4 -ml-4 font-semibold text-white">
                            <div class="absolute top-0 left-0 w-px h-full -ml-px transition-opacity bg-purple-400" />
                            {{ card.title }}
                        </h2>
                        <p class="relative p-0">
                            {{ card.content }}
                        </p>
                    </div>
                    <p
                        class="relative text-purple-400 group-hover:underline group-hover:text-purple-300"
                    >
                        Learn more
                    </p>
                </router-link>
                <div />
            </div>

            <!-- Separator -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div class="h-48" />
                <div />
                <div />
                <div />
            </div>
        </div>

        <!-- Stylized Assets -->
        <div v-if="showFeaturedAssets">
            <!-- Header -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-b border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div class="col-span-2 p-4">
                    <p class="mb-2 text-sm text-purple-400">
                        <StarIcon class="inline-block w-4 h-4 -mt-px" />
                        Featured
                    </p>
                    <h2 class="text-3xl font-semibold text-white">
                        Is realistic not your style?
                    </h2>
                    <p class="mt-2">
                        Our stylized nature assets can help you build artistic worlds.
                    </p>
                </div>
                <div />
                <div />
            </div>

            <!-- Cards -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-b border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <router-link
                    v-for="(card, index) in stylizedProductCards"
                    :key="index"
                    :to="card.to"
                    class="relative flex flex-col justify-between col-span-1 gap-2 p-4 overflow-visible group"
                >
                    <div class="absolute transition-transform duration-75 ease-out scale-95 bg-gray-800 bg-opacity-100 rounded opacity-0 -inset-px group-hover:scale-100 group-hover:opacity-100" />
                    <div class="flex flex-col gap-2">
                        <img
                            :src="card.image"
                            class="relative object-cover w-full rounded shadow-md group-hover:drop-shadow-lg"
                        >
                        <h2 class="relative pl-4 -ml-4 font-semibold text-white">
                            <div class="absolute top-0 left-0 w-px h-full -ml-px transition-opacity bg-purple-400" />
                            {{ card.title }}
                        </h2>
                        <p class="relative p-0">
                            {{ card.content }}
                        </p>
                    </div>
                    <p
                        class="relative text-purple-400 group-hover:underline group-hover:text-purple-300"
                    >
                        Learn more
                    </p>
                </router-link>
                <div class="col-span-3 p-4 border-gray-600 border-dashed">
                    <img
                        :src="StylizedNatureBanner"
                        class="md:h-[360px] object-cover w-full rounded shadow-md"
                    >
                </div>
                <div />
            </div>

            <!-- Separator -->
            <div class="grid grid-cols-2 mx-2 text-gray-300 border-l border-r border-gray-800 border-dashed divide-x divide-gray-800 md:grid-cols-4 md:mx-auto max-w-7xl divide-dashed">
                <div class="h-48" />
                <div />
                <div />
                <div />
            </div>
        </div>

        <AppFooter />
        <CookieConsent />
    </div>
</template>

<script lang="ts" setup>
import GlobalNav from "../../app/components/GlobalNav.vue";
import CookieConsent from "../../legal/components/CookieConsent.vue";
import AppFooter from "../../app/components/AppFooter.vue";
import BaseButton from "../../common/components/BaseButton.vue";
import { BookOpenIcon, ChartBarIcon, CubeIcon, StarIcon, VideoCameraIcon } from "@heroicons/vue/solid";
import HomeFeaturedImg from "./../assets/home-featured.jpg";
import NatureRendererCard from "./../assets/nature-renderer-card.jpg";
import NatureShadersCard from "./../assets/nature-shaders-card.jpg";
import RealisticMeadowCard from "./../assets/realistic-meadow-card.jpg";
import HighlightBannerImg from "./../assets/nature-renderer-osiris-new-dawn-banner.jpg";
import FeaturedBannerImg from "./../assets/home-featured-assets-banner.jpg";
import FenixFireLogo from "./../assets/fenix-fire-logo.png";
import StylizedNatureFeatured from "./../assets/stylized-nature-1.jpg";
import StylizedNatureBanner from "./../assets/stylized-nature-featured.jpg";

import OpenInNewIcon from "vue-material-design-icons/OpenInNew.vue";
import { computed, ref } from "vue";
import { useMeta } from "vue-meta";

const showMainCards = ref(false);
const showFeaturedTestimonial = ref(false);
const showFeaturedAssets = ref(true);

const mainCards = [
    {
        title: "Learn",
        content: "Knowledge is the first step towards a succesful project. Get started with our tutorials to learn Unity.",
        icon: BookOpenIcon
    }, {
        title: "Create",
        content: "Immediately create worlds with our collections of 3D models.",
        icon: CubeIcon
    }, {
        title: "Render",
        content: "Render beautiful worlds. No graphics programming or team required.",
        icon: VideoCameraIcon
    }, {
        title: "Scale",
        content: "Scale your project and team.",
        icon: ChartBarIcon
    }
];

const featuredProductCards = [
    {
        title: "Realistic Meadow",
        content: "Ready-made vegetation models to fill your world.",
        image: RealisticMeadowCard,
        to: "/realistic-nature/"
    },
    {
        title: "Nature Renderer",
        content: "Render vast amounts of vegetation.",
        image: NatureRendererCard,
        to: "/nature-renderer/"
    },
    {
        title: "Nature Shaders",
        content: "Bring your vegetation to life.",
        image: NatureShadersCard,
        to: "/nature-shaders/"
    }
];

const stylizedProductCards = [
    {
        title: "Stylized Nature",
        content: "Hand-crafted assets to bring your worlds to life.",
        image: StylizedNatureFeatured,
        to: "/stylized-nature/"
    }
];

const reviewCount = ref(8);

const filteredReviews = computed(() =>
{
    const array = reviews;
    return array.splice(0, reviewCount.value);
});

const reviews = [
    {
        user: "cookiester34",
        title: "Amazing Asset is a must have",
        content: "This basically allowed me to go from a depressing empty field to all the foliage coverage I could ask for, this is basically a must-have in any project, very nicely documented and supported as well."
    },
    {
        user: "Bwacky",
        title: "Does what it promises!",
        content: "You're literally 1 script drag away from making your terrain look beautiful. Don't look any further, just grab this and your scenes will look as if they got a new life. "
    },
    {
        user: "humman01",
        title: "Nice, fast grass",
        content: "Much faster and better looking than default terrain grass, work as good on hdpr/upr Can also render massive amount of rocks and any other lowpoly static details, they only need custom shader graph"
    },
    {
        user: "oldcrank",
        title: "Great tool and amazing support.",
        content: "Had a problem with a conflict from another asset causing grass to flash on terrain updates. Talked to the Nature Renderer devs and they helped diagnose the problem and had a workaround built into the next build, even though the problem wasn't technically caused by their code. Awesome devs. The renderer is very efficient as well so it's a keeper in my opinion. Great job!"
    },
    {
        user: "zerosimms",
        title: "Fantastic",
        content: "Works a treat in my HDRP pipeline, I've seen massive improvements in my FPS. Would recommend this in a heartbeat :) "
    },
    {
        user: "intimidate2161",
        title: "Great Unity replacement",
        content: "Since upgrading to HDRP leaves developers unable to place grass with the Unity tool, this is a great replacement."
    },
    {
        user: "Behaviour",
        title: "A must-have for projects with vegetation",
        content: "A very professionally built tool that not only improves performance tremendously with a few clicks but at the same time feels like it should be part of the default unity experience. A must-have that I couldn't do without any more. Publisher was also very friendly and helpful. Worth every penny."
    },
    {
        user: "MeHigh94",
        title: "Simple and amazing!",
        content: "Simple to use, and makes the nature look amazing! Great job! "
    },
    {
        user: "jasonxtate66",
        title: "This thing will make your terrain POP",
        content: "I was turned onto this product by Wizards Code, who does a lot of tutorials and tests a lot of assets. I put it into my Gaia terrain and wow... major improvement in details, draw distance, etc... Simply attach it to your terrain, adjust the settings, and you're good to go. Highly Recommended."
    },
    {
        user: "adjorr",
        title: "Fancy Plants",
        content: "Got this as part of a bundle, has greatly improved the look of my projects foliage without compromising performance and it is easy to interact with both through the inspector and on a script level. Support was polite and helpful."
    },
    {
        user: "JmprDev",
        title: "Outstanding",
        content: "It's easy to use, the performance gain is amazing and the support is great too!  "
    },

    {
        user: "mbach",
        title: "Excellent asset!",
        content: "Does its job perfectly with a very easy-to-use interface, works with TheVegetationEngine and the support is top notch. Could not be more satisfied."
    },
    {
        user: "ValerioMarty",
        title: "Actually does what it says it does",
        content: "massive fps improvement over regular grass, easy to use"
    },
    {
        user: "NortiXXxx",
        title: "Really nice",
        content: "Amazing asset, work really great. And documentation are useful"
    },
    {
        user: "SirFranc",
        title: "AA solution at your fingertips",
        content: "The renderer works great, as of now is the best solution for HDRP terrain and foliage, and it's integrated very well with several other functions (wind, fade, instancing), the optional extentions also work very well. The performance are also increased dramatically, highly recommended!"
    },
    {
        user: "Orestis_L",
        title: "Incredible",
        content: "Very easy installation and update, very easy to use and adapt to your project's needs. Makes the terrain details look much better and the performance is not affected. Recommended."
    },
    {
        user: "Elervax",
        title: "Performant and Beautiful",
        content: "Works well even with large open world maps, looks good and adds Wind and Detail support for HDRP. Very good supported."
    },
    {
        user: "lolaswift",
        title: "10 stars",
        content: "One of the best assets on the asset store. One of the most talented developers on the asset store. One of the reasons I'm not completely moving to Unreal."
    },
    {
        user: "Samwal21",
        title: "Awesome asset!",
        content: "Works out of the box and when I had some hiccups getting it working with The Vegetation Engine, Max was fantastic at helping me out to get everything working. Great asset and when combined with TVE it is an excellent solution for your vegetation! "
    },
    {
        user: "matt1101",
        title: "Best Optimization Asset Ever!",
        content: "This asset really is something special, not only does it eliminate the problem of grass levitating if you have a hill, mountain and etc. But it also does an amazing job at batching, my batching count went from 100000 to only around 700. There's also a good documentation site. Best asset ever!!!"
    },
    {
        user: "yeahimsteve",
        title: "I give it 6 stars out of 5 - it's that good",
        content: "I can be hard to impress sometimes.  It seems that some developers make something great, only to leave out one thing that makes the entire thing almost unusable.  This dev did no such thing.  They got it right, and right is an understatement. I give the dev praise here.  Highly deserving.  Amazing asset."
    },
    {
        user: "madookankab29",
        title: "Great Asset",
        content: "Nature Renderer is very great asset for HDRP"
    },
    {
        user: "VincentAbert",
        title: "So far, just perfect",
        content: "It does what it says. And it does it great. Just wow"
    },
    {
        user: "Escuriak",
        title: "Amazing",
        content: "Simple setup, great functionality. With this asset, you are able to use meshes as grass. What else do you need?! :D Thanky you for this"
    },
    {
        user: "DesomondoDC",
        title: "Can't imagine building terrains without it",
        content: "I've had this asset for quite some time now but have only just started using it properly.  The difference between using this and not using it is light and day. Absolutely great product and AAA support. "
    },
    {
        user: "perholmes",
        title: "Slamming asset, best purchase so far",
        content: "After fighting with Unity's terrain detail feature, I installed this, and all my problems went away. Now creating foliage is fast, simple and fun, it fixes Unity's bugs, and it renders crazy fast."
    },
    {
        user: "BruteForce93",
        title: "AWERSOME Asset!",
        content: "Very good asset, easy to set up and use, functional and powerful, usable and performance for many environments."
    },
    {
        user: "Penhoat",
        title: "Simply fantastic",
        content: "The performance gain is incredible, but simply put, you gave me grass back in HDRP"
    },
    {
        user: "castrojoaquin91",
        title: "Great asset!",
        content: "I'm using HDRP and this is a good solution if you want your grass back! It's super simple to use and it also works with multiple terrains. Good job!"
    },
    {
        user: "Lleron",
        title: "Does what it intends to do without complications",
        content: "I've had this asset for a month and I haven't encountered any problems. The asset has delivered the intended purpose of bringing your scene to life, plus in a simple manner. Just follow the instructions and you're on your way to reaching another level in environment creation. Very satified!"
    },
    {
        user: "Wildfire_Games",
        title: "Wish I found it sooner",
        content: "This plugin makes my game a lot better. Set up was really like it was described, and I only had to add the component for the renderer to work. There were a few more settings that I could tweak, but it already worked great without changing anything. "
    },
    {
        user: "oceandrivestudio",
        title: "Simple and reliable asset",
        content: "It's awesome. it enables detail of terrain in HDRP. and feedback is super fast."
    },
    {
        user: "Staggart Creations",
        title: "Vital for outdoor environments",
        content: "Unity's own vegetation system literally hasn't been updated in a decade, and really isn't up to modern standards. Both in terms density, rendering and performance. I applaud Nature Renderer to take this up and do exactly what's necessary. It renders vegetation in cells through instancing and does frustrum culling on them, resulting in realistic performance. If you were to create your own vegetation renderer, you'd just end up doing the same!  It's simple to use, as a lot of the complexity is hidden or automated. A telltale sign of a polish asset focused on user experience. Since it piggybacks on the terrain vegetation system it's compatible with other assets that spawn vegetation (eg. Gaia, Map Magic, World Creator)."
    },
    {
        user: "SNicolas",
        title: "Fantastic results and amazing support",
        content: "This is a +AAA product that keeps growing and delivers the best solution in terms of performance and visual quality. And not only this, but the amazing support is a great plus as well. You feel really connected with the developer as he is very open to suggestions and requests. "
    },
    {
        user: "Kumi_chan",
        title: "Very Good!",
        content: "The plugin is very good and beautiful result. Thank you!"
    },
    {
        user: "LazyFridayStudio",
        title: "Unity should Just buy this and integrate.",
        content: "This asset is just wonderful, Simple, Easy and well rounded. would recommend for any game that has a need for grass/flowers."
    },
    {
        user: "StonedLover",
        title: "Great asset",
        content: "Greast asset and a good support. "
    },
    {
        user: "amamasset",
        title: "A must have",
        content: "Really great asset improving a lot vegetation rendering in my scene. It looks much better now!"
    },
    {
        user: "kristoof",
        title: "Amazing!",
        content: "Seamless integration with the existing vegetation system looks beautiful and faster than the current vegetation rendering. Must have for nature/open-world projects!"
    },
    {
        user: "RyanApex",
        title: "Just download it",
        content: "One of the best assets you can put money on, does exactly what it says will cut your loads on rendering scenes down by a lot. Honestly feels like some kinda witchcraft throwing a script on and it makes it all run smoothly. Makes the default Unity vegetation system feel like a relic."
    },
    {
        user: "FlorianBernard",
        title: "Simply amazing",
        content: "This asset is super easy to use, gives excellent results in 2 clicks and support is blazing fast, efficient and super friendly. Definitely recommended! Just buy it!"
    },
    {
        user: "ClumsyRobot",
        title: "Good for HDRP!",
        content: "I have been looking to get my terrain details to work in HDRP for ages and just tried this. Everything worked immediately! It can render my grass and even includes wind. Strongly recommend!"
    },
    {
        user: "betaFlux",
        title: "Must-have asset",
        content: "for projects with vegetation-heavy terrain. It fixes the \"floating grass\" issue and drastically improves grass lighting. I'm really excited to explore this asset."
    },

    {
        user: "Lars-Steenhoff",
        title: "Its awesome !",
        content: "Thanks so much for making this ! Its makes everything beautiful with one click"
    }/*,
    {
        user: "Protofactor Inc",
        title: "Finally Something to replace properly the outdated Terrain's details",
        content: "I've just been using that tool for a few minutes now. It's very straight forward. Drag and drop the script on the terrain. use you own meshes with Standard shaders. Boom it just works!!! I've been waiting for such a tool for ages. The tool is well designed, the documentation is easy to understand. No bloating features. It just does the job! Humongous thanks to you guys for creating this!! This should have been a built-in in the engine ages ago..."
    } */
];

function onShowMoreReviewsClicked ()
{
    reviewCount.value = 80;
}

useMeta({
    title: "",
    og: {
        title: "Visual Design Cafe",
        description: "We help you create virtual worlds.",
        url: window.location.href,
        image: HomeFeaturedImg,
        publisher: "https://www.facebook.com/VisualDesignCafe/",
        modified_time: "2022-02-23T03:02:50+00:00"
    },
    twitter: {
        title: "Visual Design Cafe",
        description: "We help you create virtual worlds.",
        url: window.location.href,
        image: HomeFeaturedImg,
        site: "@VDCafe",
        card: "summary_large_image"
    }
});

</script>
